module.exports = __webpack_public_path__ + "m.no2.20d3686c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/m.no2.jpg
// module id = EbL+
// module chunks = 0